import { combineReducers } from 'redux'
import { getFlag } from './productReducer'

const reducers = combineReducers({
  getFlag: getFlag,
})

export default reducers
